import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { toast } from "react-toastify";
import { StarOutline, StarFill } from "../../../LeftNav/SvgIcons";
import { useHistory } from "react-router-dom";
import {
  Pagination,
  ListViewTile,
  Spinner,
  GridActionNotification,
} from "../../../../../components/common";
import { contactsActions } from "../../../../../store/contacts/contactsActions";
import AllContactsGrid from "../AllContactsGrid";
import { AllBusinessContactsGridFilter } from ".";
import { RoutesObj } from "../../../../../routes";
import { AllCompaniesGrid } from "../Comapnies";
import { endpoints } from "../../../../../config/apiConfig";
import CustomerGroupGrid from "../CustomerGroupGrid";
import { AddNewBusinessGroup } from "../AddNewBusinessGroup";

const DeletedBusinessContactDataView = () => {
  const dispatch = useDispatch();
  const { isBCListView } = useSelector(state => state.endUserReducer);

  const [bcList, setBCList] = useState([]);
  const [cList, setCList] = useState([]);
  const [bgList, setBGList] = useState([]);

  const [isListView, setIsListView] = useState(true);
  const [isCompListView, setIsCompListView] = useState(true);
  const [isBGListView, setIsBGListView] = useState(true);

  const [isRating, setIsRating] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [activeTabId, setActiveTabId] = useState("1");

  const [isFilterAppling, setIsFilterAppling] = useState(false);
  const [isCompFilterAppling, setIsCompFilterAppling] = useState(false);
  const [isBGFilterAppling, setIsBGFilterAppling] = useState(false);

  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isCompFilterApplied, setIsCompFilterApplied] = useState(false);
  const [isBGFilterApplied, setIsBGFilterApplied] = useState(false);

  const [filterModel, setFilters] = useState({
    searchText: "",
    startDate: "",
    endDate: "",
    productCategories: [],
    productSubCategoryId: [],
    environmentId: [],
    contactTypeIds: [],
    productName: [],
    productSKU: [],
    countryId: [],
    stateId: [],
    cityId: [],
    address: [],
    firstName: [],
    lastName: [],
    email: [],
    lastLogin: null,
    deviceRegistered: [],
    rating: null,
    companyName: null,
    date: 0,
    groupIds: null,
    id: [],
    userStatus: [-1],
  });
  const [filterCompModel, setCompFilters] = useState({
    searchText: "",
    startDate: "",
    endDate: "",
    productCategories: [],
    productSubCategoryId: [],
    environmentId: [],
    contactTypeIds: [],
    productName: [],
    productSKU: [],
    productStatus: [],
    countryId: [],
    stateId: [],
    cityId: [],
    address: [],
    firstName: [],
    lastName: [],
    email: [],
    lastLogin: null,
    deviceRegistered: [],
    rating: null,
    companyName: null,
    date: 0,
    groupIds: null,
    id: [],
    userStatus: [-1],
  });
  const [filterBGModel, setBGFilters] = useState({
    searchText: "",
    startDate: "",
    endDate: "",
    productCategories: [],
    productSubCategoryId: [],
    environmentId: [],
    contactTypeIds: [],
    productName: [],
    productSKU: [],
    countryId: [],
    stateId: [],
    cityId: [],
    address: [],
    firstName: [],
    lastName: [],
    email: [],
    color: "",
    lastLogin: null,
    deviceRegistered: [],
    rating: null,
    companyName: null,
    date: 0,
    groupIds: null,
    id: [],
    productStatus: [],
    userStatus: [-1],
  });

  const [bcPaginationResponse, setBCPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [cPaginationResponse, setCPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [bgPaginationResponse, setBGPaginationResponse] = useState({
    currentCount: 0,
    totalRecords: 0,
  });
  const [bcPage, setBCPage] = useState(1);
  const [cPage, setCPage] = useState(1);
  const [bgPage, setBGPage] = useState(1);

  const [rowsPerPageBC, setRowsPerPageBC] = useState(10);
  const [rowsPerPageC, setRowsPerPageC] = useState(10);
  const [rowsPerPageBG, setRowsPerPageBG] = useState(10);

  const [bcOrderBy, setBCOrderBy] = useState({
    orderByKey: "Id",
    orderVal: 0,
  });
  const [cOrderBy, setCOrderBy] = useState({
    orderByKey: "Id",
    orderVal: 0,
  });
  const [bgOrderBy, setBGOrderBy] = useState({
    orderByKey: "Id",
    orderVal: 0,
  });

  const [editableRecord, setEditableRecord] = useState(null);

  const history = useHistory();

  const redirectToBusinessCContact = value => {
    history.push({
      pathname: RoutesObj.BusinessCustomer.path,
      companyId: value.companyId,
      search: `id=${value.companyId}`,
      state: { scrollTo: ".businessContacts" },
    });
  };

  const redirectToCompany = value => {
    history.push({
      pathname: RoutesObj.NewCompanyContacts.path,
      state: { company: value },
      search: `id=${value.companyId}`,
    });
  };

  const loadCustomerList = useCallback(() => {
    const modal = {
      ...filterModel,
      email:
        filterModel.email?.length > 0
          ? filterModel.email.map(em => em.email)
          : [],
      firstName:
        filterModel.firstName?.length > 0
          ? filterModel.firstName.map(fn => fn.id)
          : [],
      lastName:
        filterModel.lastName?.length > 0
          ? filterModel.lastName.map(ln => ln.id)
          : [],
      id: filterModel.id?.length > 0 ? filterModel.id.map(ln => ln.id) : [],
      productCategories:
        filterModel.productCategories?.length > 0
          ? filterModel.productCategories.map(pc => pc.id)
          : [],
      productSubCategoryId:
        filterModel.productSubCategoryId?.length > 0
          ? filterModel.productSubCategoryId.map(pc => pc.id)
          : [],
      deviceRegistered:
        filterModel.deviceRegistered?.length > 0
          ? filterModel.deviceRegistered.map(dr => dr.id)
          : [],
      environmentId:
        filterModel.environmentId?.length > 0
          ? filterModel.environmentId.map(env => env)
          : [],
      productName:
        filterModel.productName?.length > 0
          ? filterModel.productName.map(pn => pn.id)
          : [],
      productSKU:
        filterModel.productSKU?.length > 0
          ? filterModel.productSKU.map(ps => ps.id)
          : [],
      countryId:
        filterModel.countryId?.length > 0
          ? filterModel.countryId.map(ct => ct.value)
          : [],
      stateId:
        filterModel.stateId?.length > 0
          ? filterModel.stateId.map(st => st.value)
          : [],
      cityId:
        filterModel.cityId?.length > 0
          ? filterModel.cityId.map(ct => ct.value)
          : [],
      address:
        filterModel.address?.length > 0
          ? filterModel.address.map(ct => ct.value)
          : [],
      productStatus: [],
      pagination: {
        pageSize: rowsPerPageBC,
        pageNo: bcPage,
        orderByKey: bcOrderBy.orderByKey,
        orderByVal: bcOrderBy.orderVal,
      },
    };
    setLoading(true);

    Promise.all([
      dispatch(
        contactsActions.onGetCustomerList({
          ...modal,
          pagination: {
            ...modal.pagination,
            pageSize: rowsPerPageBC,

            pageNo: bcPage,
            orderByKey: bcOrderBy.orderByKey,
            orderByVal: bcOrderBy.orderVal,
          },
        })
      ),
    ]).then(([businessContacts]) => {
      if (
        businessContacts &&
        businessContacts.success &&
        businessContacts.data?.data
      ) {
        setBCPaginationResponse(businessContacts?.data?.pagination);
        setBCList(businessContacts.data.data);
      }
      if (isFilterAppling) {
        setIsFilterApplied(true);
      }
      setIsFilterAppling(false);
      setLoading(false);
    });
  }, [
    filterModel,
    rowsPerPageBC,
    bcPage,
    bgPage,
    bcOrderBy.orderByKey,
    bcOrderBy.orderVal,
    dispatch,
  ]);

  const loadCompCustomerList = useCallback(() => {
    const modal = {
      ...filterCompModel,
      rating: filterCompModel?.rating?.toString(),
      email:
        filterCompModel.email?.length > 0
          ? filterCompModel.email.map(em => em.email)
          : [],
      firstName:
        filterCompModel.firstName?.length > 0
          ? filterCompModel.firstName.map(fn => fn.id)
          : [],
      lastName:
        filterCompModel.lastName?.length > 0
          ? filterCompModel.lastName.map(ln => ln.id)
          : [],
      id:
        filterCompModel.id?.length > 0
          ? filterCompModel.id.map(ln => ln.id)
          : [],
      productCategories:
        filterCompModel.productCategories?.length > 0
          ? filterCompModel.productCategories.map(pc => pc.id)
          : [],
      productSubCategoryId:
        filterCompModel.productSubCategoryId?.length > 0
          ? filterCompModel.productSubCategoryId.map(pc => pc.id)
          : [],
      deviceRegistered:
        filterCompModel.deviceRegistered?.length > 0
          ? filterCompModel.deviceRegistered.map(dr => dr.id?.toString())
          : [],
      environmentId:
        filterCompModel.environmentId?.length > 0
          ? filterCompModel.environmentId.map(env => env)
          : [],
      productName:
        filterCompModel.productName?.length > 0
          ? filterCompModel.productName.map(pn => pn.id)
          : [],
      productSKU:
        filterModel.productSKU?.length > 0
          ? filterModel.productSKU.map(ps => ps.id)
          : [],
      countryId:
        filterCompModel.countryId?.length > 0
          ? filterCompModel.countryId.map(ct => ct.value)
          : [],
      stateId:
        filterCompModel.stateId?.length > 0
          ? filterCompModel.stateId.map(st => st.value)
          : [],
      cityId:
        filterCompModel.cityId?.length > 0
          ? filterCompModel.cityId.map(ct => ct.value)
          : [],
      address:
        filterCompModel.address?.length > 0
          ? filterCompModel.address.map(ct => ct.value)
          : [],
      productStatus:
        filterCompModel?.productStatus?.length > 0
          ? filterCompModel.productStatus
          : [],
      pagination: {
        pageSize: rowsPerPageBC,
        pageNo: bcPage,
        orderByKey: bcOrderBy.orderByKey,
        orderByVal: bcOrderBy.orderVal,
      },
    };
    setLoading(true);

    Promise.all([
      dispatch(
        contactsActions.onGetComapnies({
          ...modal,
          pagination: {
            ...modal.pagination,
            pageSize: rowsPerPageC,
            pageNo: cPage,
            orderByKey: cOrderBy.orderByKey,
            orderByVal: cOrderBy.orderVal,
          },
        })
      ),
    ]).then(([companies]) => {
      if (companies && companies.success && companies.data?.data) {
        setCPaginationResponse(companies?.data?.pagination);
        setCList(companies.data.data);
      }
      if (isCompFilterAppling) {
        setIsCompFilterApplied(true);
      }
      setIsCompFilterAppling(false);
      setLoading(false);
    });
  }, [
    filterCompModel,
    rowsPerPageC,
    cPage,
    cOrderBy.orderByKey,
    cOrderBy.orderVal,
    dispatch,
  ]);

  const loadBGCustomerList = useCallback(() => {
    const modal = {
      ...filterBGModel,
      rating: filterBGModel?.rating?.toString(),
      email:
        filterBGModel.email?.length > 0
          ? filterBGModel.email.map(em => em.email)
          : [],
      firstName:
        filterBGModel.firstName?.length > 0
          ? filterBGModel.firstName.map(fn => fn.id)
          : [],
      lastName:
        filterBGModel.lastName?.length > 0
          ? filterBGModel.lastName.map(ln => ln.id)
          : [],
      id: filterBGModel.id?.length > 0 ? filterBGModel.id.map(ln => ln.id) : [],
      productCategories:
        filterBGModel.productCategories?.length > 0
          ? filterBGModel.productCategories.map(pc => pc.id)
          : [],
      productSubCategoryId:
        filterBGModel.productSubCategoryId?.length > 0
          ? filterBGModel.productSubCategoryId.map(pc => pc.id)
          : [],
      deviceRegistered:
        filterBGModel.deviceRegistered?.length > 0
          ? filterBGModel.deviceRegistered.map(dr => dr.id)
          : [],
      environmentId:
        filterBGModel.environmentId?.length > 0
          ? filterBGModel.environmentId.map(env => env)
          : [],
      productName:
        filterBGModel.productName?.length > 0
          ? filterBGModel.productName.map(pn => pn.id)
          : [],
      productSKU:
        filterBGModel.productSKU?.length > 0
          ? filterBGModel.productSKU.map(ps => ps.id)
          : [],
      countryId:
        filterBGModel.countryId?.length > 0
          ? filterBGModel.countryId.map(ct => ct.value)
          : [],
      stateId:
        filterBGModel.stateId?.length > 0
          ? filterBGModel.stateId.map(st => st.value)
          : [],
      cityId:
        filterBGModel.cityId?.length > 0
          ? filterBGModel.cityId.map(ct => ct.value)
          : [],
      address:
        filterBGModel.address?.length > 0
          ? filterBGModel.address.map(ct => ct.value)
          : [],
      pagination: {
        pageSize: rowsPerPageBC,
        pageNo: bcPage,
        orderByKey: bcOrderBy.orderByKey,
        orderByVal: bcOrderBy.orderVal,
      },
    };
    setLoading(true);

    Promise.all([
      dispatch(
        contactsActions.onGetBusinessGroupListSearch({
          ...modal,
          pagination: {
            ...modal.pagination,
            pageSize: rowsPerPageBG,
            pageNo: bgPage,
            orderByKey: bgOrderBy.orderByKey,
            orderByVal: bgOrderBy.orderVal,
          },
        })
      ),
    ]).then(([businessGroups]) => {
      if (
        businessGroups &&
        businessGroups.success &&
        businessGroups.data?.data
      ) {
        setBGPaginationResponse(businessGroups?.data?.pagination);
        setBGList(businessGroups.data.data);
      }
      if (isBGFilterAppling) {
        setIsBGFilterApplied(true);
      }
      setIsBGFilterAppling(false);
      setLoading(false);
    });
  }, [
    filterBGModel,
    rowsPerPageBG,
    bgPage,
    bgOrderBy.orderByKey,
    bgOrderBy.orderVal,
    dispatch,
  ]);

  useEffect(() => {
    loadCustomerList();
  }, [loadCustomerList]);

  useEffect(() => {
    loadCompCustomerList();
  }, [loadCompCustomerList]);

  useEffect(() => {
    loadBGCustomerList();
  }, [loadBGCustomerList]);

  useEffect(() => {
    setIsListView(isBCListView);
  }, [isBCListView]);

  const onMarkFavouriteCustomer = ({ selectedCustomers }) => {
    setLoading(true);
    dispatch(contactsActions.onMarkFavouriteCustomer(selectedCustomers)).then(
      data => {
        setLoading(false);
        if (!data?.data?.success) {
          toast.error(data?.message || "Something went wrong!");
        } else {
          toast.success("User removed from favourites!");
          loadCustomerList();
        }
      }
    );
  };

  const onMarkFavouriteCompanies = ({ selectedCustomers }) => {
    setLoading(true);
    dispatch(
      contactsActions.onMarkUnMarkFavouriteCompanies(selectedCustomers)
    ).then(data => {
      setLoading(false);
      if (!data?.success) toast.error(data?.message || "Something went wrong!");
      else toast.success("Company removed from favourites!");
      loadCompCustomerList();
    });
  };

  const onMarkFavEndUserGroup = selectedGroup => {
    setLoading(true);
    dispatch(
      contactsActions.onPostCustomersEndpoint({
        endpoint: endpoints.customers.markUnMarkFavouriteUserGroup,
        data: [
          {
            groupId: selectedGroup.groupId,
            isFavourite: !selectedGroup.isFavorite,
          },
        ],
      })
    ).then(data => {
      setLoading(false);
      if (!data?.success) {
        toast.error(data?.message);
        loadBGCustomerList();
      } else {
        toast.success("Group removed from favourites!");
        loadBGCustomerList();
      }
    });
  };
  const handleApplyFilters = filters => {
    const { zipCodeData, ...updatedFilters } = filters;

    setCompFilters(updatedFilters);
  };

  return (
    <>
      <div
        className='gridBody contentBody fav-business-c-c-g'
        style={{
          // width: "100%",
          paddingRight: "20px !important",
        }}>
        {isLoading ? <Spinner /> : null}
        <AllBusinessContactsGridFilter
          IsFilterApplied={isFilterApplied}
          // PaginationResponse={paginationResponse}
          AppliedFilters={filterModel}
          onApplyFilters={(filters, isFilterApplied) => {
            setFilters({ ...filters, userStatus: [-1, ...filters.userStatus] });
            if (isFilterApplied) setIsFilterAppling(isFilterApplied);
            else {
              setIsFilterAppling(false);
              setIsFilterApplied(false);
            }
          }}
          ActiveTabId={activeTabId}
          setActiveTabId={setActiveTabId}
          isListView={isListView}
          onToggleListView={isLstView => setIsListView(isLstView)}
          title={"Business Contacts Filter"}
        />
        {/* <GridActionNotification
          notificationtext={"Users who are deleted will be permanently deleted from OFish after 30 days."}
          learnmore={() => {}}
          bgcolor={"#EB5757"}
        /> */}

        <h2 className='gridInnerHeading'>
          {`Deleted Business Contacts`}
          <span className='gridTopPagination'>
            <Pagination
              recordCount={bcPaginationResponse?.totalRecords}
              page={bcPage - 1}
              rowsPerPage={rowsPerPageBC}
              setRowsPerPage={setRowsPerPageBC}
              rowsPerPageOptions={[]}
              backIconButtonProps={{ style: { display: "none" } }}
              nextIconButtonProps={{ style: { display: "none" } }}
            />
          </span>
        </h2>

        {isListView ? (
          <AllContactsGrid
            isDeleted={true}
            allContactsData={bcList}
            startLoading={() => setLoading(true)}
            endLoading={() => setLoading(false)}
            loadData={() => loadCustomerList()}
            order={bcOrderBy}
            onOrderBy={setBCOrderBy}
            onMarkFavouriteCustomer={onMarkFavouriteCustomer}
          />
        ) : (
          <Grid container spacing={2}>
            {bcList.map(item => {
              return (
                <Grid item md={3} key={item?.id}>
                  <ListViewTile
                    companyname={item?.companyName}
                    contacts={item.contacts}
                    buttontxt={item.groupName}
                    backgroundcolor={item.groupColor}
                    textcolor={item.textcolor}
                    rating={item?.isFavourite ? <StarFill /> : <StarOutline />}
                    onRatingClick={() => setIsRating(!isRating)}
                    onClick={() => redirectToBusinessCContact(item)}
                    onMarkFavourite={() =>
                      onMarkFavouriteCustomer({
                        selectedCustomers: [
                          {
                            userId: item.userId,
                            isFavourite: !item?.isFavourite,
                          },
                        ],
                      })
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
        )}

        <Pagination
          recordCount={bcPaginationResponse?.totalRecords}
          page={bcPage - 1}
          setPage={setBCPage}
          rowsPerPage={rowsPerPageBC}
          setRowsPerPage={setRowsPerPageBC}
        />
      </div>
      <div
        className='gridBody contentBody fav-business-c-c-g'
        style={{
          // width: "100%",
          paddingRight: "20px !important",
        }}>
        {isLoading ? <Spinner /> : null}

        <AllBusinessContactsGridFilter
          IsFilterApplied={isCompFilterApplied}
          // PaginationResponse={paginationResponse}
          AppliedFilters={filterCompModel}
          onApplyFilters={(filters, isCompFilterApplied) => {
            const { zipcode, ...filteredFilters } = filters;
            handleApplyFilters({ ...filteredFilters, userStatus: [-1] });
            if (isCompFilterApplied)
              setIsCompFilterAppling(isCompFilterApplied);
            else {
              setIsCompFilterAppling(false);
              setIsCompFilterApplied(false);
            }
          }}
          ActiveTabId={activeTabId}
          setActiveTabId={setActiveTabId}
          isListView={isCompListView}
          onToggleListView={isLstView => setIsCompListView(isLstView)}
          // hideFilters={"Favorite Companies"}
          title={"Deleted Companies Filter"}
          hideFilters={"favFilter"}
        />

        <h2 className='gridInnerHeading'>
          {`Deleted Companies`}
          <span className='gridTopPagination'>
            <Pagination
              recordCount={cPaginationResponse?.totalRecords}
              page={cPage - 1}
              rowsPerPage={rowsPerPageC}
              setRowsPerPage={setCPaginationResponse}
              rowsPerPageOptions={[]}
              backIconButtonProps={{ style: { display: "none" } }}
              nextIconButtonProps={{ style: { display: "none" } }}
            />
          </span>
        </h2>

        {isCompListView ? (
          <AllCompaniesGrid
            listData={cList}
            isDeleted={true}
            setLoading={setLoading}
            loadData={() => loadCompCustomerList()}
            order={cOrderBy}
            onOrderBy={setCOrderBy}
            onMarkFavouriteCompanies={onMarkFavouriteCompanies}
          />
        ) : (
          <Grid container spacing={2}>
            {cList.map((item, index) => {
              return (
                <Grid item md={3}>
                  <ListViewTile
                    companyname={item.companyName}
                    contacts={
                      item?.totalUsers > 0
                        ? `${item?.totalUsers} Contact${
                            item?.totalUsers > 1 ? "s" : ""
                          }`
                        : "No Contact"
                    }
                    buttontxt={item.businessGroup}
                    backgroundcolor={item.backgroundcolor}
                    textcolor={item.textcolor}
                    rating={item?.isFavourite ? <StarFill /> : <StarOutline />}
                    onRatingClick={() => {}}
                    onClick={() => redirectToCompany(item)}
                    onMarkFavourite={() =>
                      onMarkFavouriteCompanies({
                        selectedCustomers: {
                          companyId: item.companyId,
                          isFavourite: !item?.isFavourite,
                        },
                      })
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
        )}
        <Pagination
          recordCount={cPaginationResponse?.totalRecords}
          page={cPage - 1}
          setPage={setCPage}
          rowsPerPage={rowsPerPageC}
          setRowsPerPage={setRowsPerPageC}
        />
      </div>
      <div
        className='gridBody contentBody fav-business-c-c-g'
        style={{
          // width: "100%",
          paddingRight: "20px !important",
        }}>
        {isLoading ? <Spinner /> : null}

        <AllBusinessContactsGridFilter
          IsFilterApplied={isBGFilterApplied}
          // PaginationResponse={paginationResponse}
          AppliedFilters={filterBGModel}
          onApplyFilters={(filters, isBGFilterApplied) => {
            const { zipcode, ...filteredFilters } = filters;
            setBGFilters({ ...filteredFilters, userStatus: [-1] });
            if (isBGFilterApplied) setIsBGFilterAppling(isBGFilterApplied);
            else {
              setIsBGFilterAppling(false);
              setIsBGFilterApplied(false);
            }
          }}
          ActiveTabId={activeTabId}
          setActiveTabId={setActiveTabId}
          isListView={isBGListView}
          onToggleListView={isLstView => setIsBGListView(isLstView)}
          title={"Deleted Business Groups Filter"}
          hideFilters={"favGroupFilter"}
        />

        <h2 className='gridInnerHeading'>
          {`Deleted Business Groups`}
          <span className='gridTopPagination'>
            <Pagination
              recordCount={bgPaginationResponse?.totalRecords}
              page={bgPage - 1}
              rowsPerPage={rowsPerPageBG}
              setRowsPerPage={setRowsPerPageBG}
              rowsPerPageOptions={[]}
              backIconButtonProps={{ style: { display: "none" } }}
              nextIconButtonProps={{ style: { display: "none" } }}
            />
          </span>
        </h2>

        {isBGListView ? (
          <CustomerGroupGrid
            isDeleted={true}
            customerGroupsData={bgList}
            startLoading={() => setLoading(true)}
            stopLoading={() => setLoading(false)}
            loadData={() => loadBGCustomerList()}
            order={bgOrderBy}
            onOrderBy={setBGOrderBy}
            onEditClick={businessGroupEntity => {
              if (businessGroupEntity)
                setEditableRecord({ ...businessGroupEntity });
            }}
            onMarkFavEndUserGroup={onMarkFavEndUserGroup}
            EditableRecord={editableRecord}
            EditAbleRow={
              editableRecord && (
                <AddNewBusinessGroup
                  id='add-new-business-group'
                  businessGroupEntity={editableRecord}
                  onAddUpdate={success => {
                    if (success) {
                      loadCustomerList();
                      setEditableRecord(null);
                    }
                  }}
                  onCancel={() => {
                    setEditableRecord(null);
                  }}
                />
              )
            }
          />
        ) : (
          <Grid container spacing={2}>
            {bgList.map(item => {
              return (
                <Grid item md={3} key={item.id}>
                  <ListViewTile
                    companyname={item?.groupName}
                    contacts={
                      item?.totalContacts > 0
                        ? `${item?.totalContacts} Contact${
                            item?.totalContacts > 1 ? "s" : ""
                          }`
                        : "No Contact"
                    }
                    buttontxt={item.customerType}
                    backgroundcolor={item.color}
                    textcolor={item.color}
                    rating={item?.isFavourite ? <StarFill /> : <StarOutline />}
                    onMarkFavourite={() =>
                      onMarkFavEndUserGroup({
                        ...item,
                      })
                    }
                  />
                </Grid>
              );
            })}
          </Grid>
        )}

        <Pagination
          recordCount={bgPaginationResponse?.totalRecords}
          page={bgPage - 1}
          setPage={setBGPage}
          rowsPerPage={rowsPerPageBG}
          setRowsPerPage={setRowsPerPageBG}
        />
      </div>
    </>
  );
};
export { DeletedBusinessContactDataView };
